import { __rest } from "tslib";
import React, { useState, useEffect } from 'react';
import { Table } from 'antd';
import { Resizable } from 'react-resizable';
const ResizableTitle = (props) => {
    const { onResize, width } = props, restProps = __rest(props, ["onResize", "width"]);
    if (!width) {
        return React.createElement("th", Object.assign({}, restProps));
    }
    return (React.createElement(Resizable, { width: width, height: 0, handle: React.createElement("span", { className: "react-resizable-handle", onClick: e => {
                e.stopPropagation();
            } }), onResize: onResize, draggableOpts: { enableUserSelectHack: false } },
        React.createElement("th", Object.assign({}, restProps))));
};
const ResizeTable = (props) => {
    var _a;
    let originColumns = (_a = props.columns) !== null && _a !== void 0 ? _a : [];
    const [columns, setColumns] = useState(originColumns);
    useEffect(() => {
        setColumns(originColumns);
    }, [originColumns]);
    const handleResize = (index) => (_, { size }) => {
        const newColumns = [...columns];
        newColumns[index] = Object.assign(Object.assign({}, newColumns[index]), { width: size.width });
        setColumns(newColumns);
    };
    const tableColumns = columns.map((col, index) => (Object.assign(Object.assign({}, col), { onHeaderCell: (column) => ({
            width: column.width,
            onResize: handleResize(index),
        }) })));
    return (React.createElement(Table, Object.assign({}, props, { components: {
            header: {
                cell: ResizableTitle,
            },
        }, columns: tableColumns })));
};
export default ResizeTable;
